import BlmMonitor from 'blm-monitor';
import { queryParams } from './tools';

// 处理用户config配置信息
export const handleConfig = (opts) => {
  const { appnm = '', category, Vue, tenantId: tenantIdFromCustom, isInApp, uid, ...rest } = opts || {};
  if (Vue) {
    Vue.prototype.$BlmMonitor = BlmMonitor;
  }
  const { pageTraceId, debug, appTraceId, tenantId } = queryParams;
  const common = {
    ...rest,
    blmDebug: debug,
    blmPageTraceId: pageTraceId,
    blmTraceId: appTraceId,
    channel: 'h5',
    Vue,
    isInApp
  };
  const inAppConf = {
    ...common,
    appnm: '',
    category: '',
    pageTraceId: pageTraceId || '',
    page: {
      auto: false, // 是否自动上报页面性能日志，默认为true
      sensory: true, // 是否开启MutationObserver监听DOM变化，默认为false
      sensoryTime: 3, // MutationObserver监控时间（时间戳），默认3秒
      delay: 0, // 页面性能日志延时上报时间（时间戳），默认0秒
      sample: 1 // 页面性能日志采样率，默认1, 采样率[0,1]
    }
  };
  const outAppConf = {
    ...common,
    category: category || 'dj', // 业务线
    appnm: appnm || 'dj-driver',
    tenantId: tenantIdFromCustom || tenantId || '',
    uid: uid || ''
  };
  return isInApp ? inAppConf : outAppConf;
};

// 上报TTI指标
export const observerTTI = (report) => {
  // 手动上报TTI指标
  let times = 0;
  Object.defineProperty(window, 'ISFIRSTSKELETONSCREEN', {
    get() {
      return this;
    },
    set() {
      times = times + 1;
      // 只有首屏上报
      if (times <= 1) {
        report({
          type: 'timeToInteractive', // timeToInteractive为TTI事件名
          timeStamp: +new Date()
        });
      }
    }
  });
};

// 上报白屏
export const checkWhiteScreen = (name) => {
  setTimeout(function () {
    var app = document.getElementById('app');
    if (!app || !app.childNodes?.length) {
      if (typeof BlmMonitor === 'object' && BlmMonitor) {
        BlmMonitor.addError(
          { name: 'WhiteScreen', msg: name + '白屏了' },
          { errorType: 'customError', level: 'error' }
        );
      }
    }
  }, 6000);
};

// 触发TTI
export const triggerMonitorTTI = () => {
  window.ISFIRSTSKELETONSCREEN = window.performance.now();
};
